import React, { useEffect, useState } from "react";

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: -100, y: -100 });
  const [trail, setTrail] = useState([]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;

      setPosition({ x: clientX, y: clientY });

      // Add new point to trail
      setTrail((prev) => [
        ...prev,
        {
          x: clientX,
          y: clientY,
          id: Date.now() + Math.random(), // unique key
        },
      ]);
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  // Automatically remove old trail dots
  useEffect(() => {
    const interval = setInterval(() => {
      setTrail((prev) => prev.slice(-10)); // keep last 10 points
    }, 50); // every 50ms

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* Main Dot */}
      <div
        className="fixed pointer-events-none w-3 h-3 rounded-full bg-blue-500 z-[9999] shadow-[0_0_12px_4px_rgba(59,130,246,0.7)] transition-transform duration-100 ease-linear"
        style={{
          left: position.x,
          top: position.y,
          transform: "translate(-50%, -50%)",
        }}
      />

      {/* Meteor Trail */}
      {trail.map((point, index) => (
        <div
          key={point.id}
          className="fixed pointer-events-none w-1 h-1 rounded-full bg-blue-400 z-[9998] opacity-50"
          style={{
            left: point.x,
            top: point.y,
            transform: "translate(-50%, -50%)",
            transition: "all 0.2s ease-out",
            animation: "fadeOut 3s forwards",
          }}
        />
      ))}

      {/* Fade-out animation */}
      <style>{`
        @keyframes fadeOut {
          from {
            opacity: 0.5;
            transform: scale(1);
          }
          to {
            opacity: 0;
            transform: scale(0.5);
          }
        }
      `}</style>
    </>
  );
};

export default CustomCursor;
